
























































































































import Vue from 'vue';
import Component from 'vue-class-component';
import VueApexCharts from 'vue-apexcharts/dist/vue-apexcharts';
import reportsRepository from '../../shared/repositories/reports.repository';
import { getMonthShortName } from '@/modules/shared/shared/domain/functions/date-functions';
import { DataCenters, Parameters } from '@/modules/shared/shared/domain/constants/constants';
import CardRadialBarChart from '@/modules/reports/dashboard/components/CardRadialBarChart.vue';
import CardInterruptionTimeAverage from '@/modules/reports/dashboard/components/CardInterruptionTimeAverage.vue';
import EnvironmentalControlChart from '@/modules/reports/dashboard/components/EnvironmentalControlChart.vue';
import EnvironmentalControlSystemAvailability from '@/modules/reports/dashboard/components/EnvironmentalControlSystemAvailability.vue';
import QuarterSummaryCardContent from '@/modules/reports/dashboard/components/QuarterSummaryCardContent.vue';
import QuarterInterruptionSummary from '@/modules/reports/dashboard/components/QuarterInterruptionSummary.vue';
import { layout, reportsDashboard } from '@/modules/shared/shared/store/namespaces';
import { ReportsDashboardGetters } from '@/modules/reports/dashboard/store/reports-dashboard.getters';
import { QuarterSummaryContent } from '@/modules/reports/dashboard/domain/quarter-summary-content';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import { ReportsDashboardActions } from '@/modules/reports/dashboard/store/reports-dashboard.actions';
import { MonthInterruptionSummary } from '@/modules/reports/dashboard/domain/month-interruption-summary';
import { DatacenterMonthIncident } from '@/modules/reports/dashboard/domain/datacenter-month-incident';
import { DatacenterBuilding } from '@/modules/reports/dashboard/domain/datacenter-building';

@Component({
    components: {
        apexchart: VueApexCharts,
        CardRadialBarChart,
        CardInterruptionTimeAverage,
        EnvironmentalControlChart,
        EnvironmentalControlSystemAvailability,
        QuarterSummaryCardContent,
        QuarterInterruptionSummary,
    },
})
export default class ReportsDashboard extends Vue {
    loadingError: boolean = false;

    isFetchingData: boolean = true;

    // TODO: Moverlo a un archivo de constantes
    TEMPERATURE_PARAMETER_ID: number = 1;
    HUMIDITY_PARAMETER_ID: number = 2;

    monthInterruptionSeries: { name: string; data: number[] }[] = [];
    monthInterruptionCategories: string[] = [];

    environmentControlContentLoaded: boolean = false;
    environmentControlOptions: {
        dataCenter: {
            id: number;
            name: string;
            temperature: {
                categories: string[];
                series: {
                    name: string;
                    data: number[];
                }[];
            };
            humidity: {
                categories: string[];
                series: {
                    name: string;
                    data: number[];
                }[];
            };
        };
    }[] = [];

    dataCenterDisponibilityCharts: {
        id: number;
        title: string;
        cardColor: string;
        chartColor: string;
        chartColorTo: string;
        fontColor: string;
    }[] = [
        {
            id: 1,
            title: 'Disponibilidad del Sistema de Respaldo CTDC',
            cardColor: '#fff',
            chartColor: '#00aab8',
            chartColorTo: '',
            fontColor: '#464855',
        },
        {
            id: 2,
            title: 'Disponibilidad del Sistema de Respaldo CDTV',
            cardColor: '#fff',
            chartColor: '#60bb46',
            chartColorTo: '',
            fontColor: '#464855',
        },
    ];

    async mounted() {
        this.changeTitle({ title: 'Disponibilidad del Data Center', route: ['REPORTES'] });
        this.isFetchingData = true;
        const failed = await this.fetchDashboard();
        if (!failed) {
            this.getMonthDataCenterIncidentsChartOptions();
            try {
                //TODO: Mover a store
                this.getEnvironmentControlReports(this.dataCenterBuildings);
            } catch (ex) {
                this.loadingError = true;
            }
        } else {
            (failed as ExceptionMessage).showError();
        }

        this.isFetchingData = false;
    }

    getEnvironmentChartOptions(
        buildingReports,
        dataCenterReportsCategoriesCcs,
        dataCenterReportsSeriesCcs,
        categoriesAdded,
    ): void {
        for (let i = 0; i < buildingReports.length; i++) {
            if (!categoriesAdded) {
                dataCenterReportsCategoriesCcs.push(buildingReports[i].date);
            }
            dataCenterReportsSeriesCcs.push(parseInt(buildingReports[i].value.replace('.', ',')));
        }
    }

    addSeriesReportsEnvironmetData(seriesChartObject, building: string, data: number[]): void {
        seriesChartObject.push({
            name: building,
            data,
        });
    }

    async getEnvironmentControlReports(
        dataCenterBuildings: {
            dataCenterId: number;
            dataCenter: string;
            buildingId: number;
            building: string;
            parameterId: number;
            parameter: string;
        }[],
    ): Promise<void> {
        const temperatureSeriesCcs: { name: string; data: number[] }[] = [];
        const humiditySeriesCcs: { name: string; data: number[] }[] = [];
        const temperatureSeriesVal: { name: string; data: number[] }[] = [];
        const humiditySeriesVal: { name: string; data: number[] }[] = [];

        let temperatureCategoriesAddedCcs: boolean = false;
        let temperatureCategoriesAddedVal: boolean = false;
        let humidityCategoriesAddedCcs: boolean = false;
        let humidityCategoriesAddedVal: boolean = false;

        const temperatureReportsCategoriesCcs: string[] = [];
        const humidityReportsCategoriesCcs: string[] = [];
        const temperatureReportsCategoriesVal: string[] = [];
        const humidityReportsCategoriesVal: string[] = [];

        for await (const element of dataCenterBuildings) {
            const buildingReportsData: number[] = [];
            const buildingReportsResponse = await reportsRepository.getBuildingsReports(
                element.buildingId,
                element.parameterId,
            );
            const buildingReports = buildingReportsResponse.data;

            if (element.dataCenterId === DataCenters.DATA_CENTER_CARACAS.id) {
                if (element.parameterId === Parameters.TEMPERATURE.id) {
                    this.getEnvironmentChartOptions(
                        buildingReports,
                        temperatureReportsCategoriesCcs,
                        buildingReportsData,
                        temperatureCategoriesAddedCcs,
                    );
                    this.addSeriesReportsEnvironmetData(
                        temperatureSeriesCcs,
                        element.building,
                        buildingReportsData,
                    );
                    temperatureCategoriesAddedCcs = true;
                } else {
                    this.getEnvironmentChartOptions(
                        buildingReports,
                        humidityReportsCategoriesCcs,
                        buildingReportsData,
                        humidityCategoriesAddedCcs,
                    );
                    this.addSeriesReportsEnvironmetData(
                        humiditySeriesCcs,
                        element.building,
                        buildingReportsData,
                    );
                    humidityCategoriesAddedCcs = true;
                }
            } else {
                if (element.parameterId === Parameters.TEMPERATURE.id) {
                    this.getEnvironmentChartOptions(
                        buildingReports,
                        temperatureReportsCategoriesVal,
                        buildingReportsData,
                        temperatureCategoriesAddedVal,
                    );
                    this.addSeriesReportsEnvironmetData(
                        temperatureSeriesVal,
                        element.building,
                        buildingReportsData,
                    );
                    temperatureCategoriesAddedVal = true;
                } else {
                    this.getEnvironmentChartOptions(
                        buildingReports,
                        humidityReportsCategoriesVal,
                        buildingReportsData,
                        humidityCategoriesAddedVal,
                    );
                    this.addSeriesReportsEnvironmetData(
                        humiditySeriesVal,
                        element.building,
                        buildingReportsData,
                    );
                    humidityCategoriesAddedVal = true;
                }
            }
        }

        this.environmentControlOptions.push({
            dataCenter: {
                id: DataCenters.DATA_CENTER_CARACAS.id,
                name: DataCenters.DATA_CENTER_CARACAS.alias,
                temperature: {
                    categories: temperatureReportsCategoriesCcs,
                    series: temperatureSeriesCcs,
                },
                humidity: {
                    categories: humidityReportsCategoriesCcs,
                    series: humiditySeriesCcs,
                },
            },
        });

        this.environmentControlOptions.push({
            dataCenter: {
                id: DataCenters.DATA_CENTER_VALENCIA.id,
                name: DataCenters.DATA_CENTER_VALENCIA.alias,
                temperature: {
                    categories: temperatureReportsCategoriesVal,
                    series: temperatureSeriesVal,
                },
                humidity: {
                    categories: humidityReportsCategoriesVal,
                    series: humiditySeriesVal,
                },
            },
        });

        this.environmentControlContentLoaded = true;
    }

    getTimeDifference(currentMonthAverage: number, lastMonthAverage: number): number {
        return currentMonthAverage - lastMonthAverage;
    }

    get monthInterruptionOptions() {
        return {
            chart: {
                type: 'bar',
                size: 300,
                // maxHeight: 350,
                // maxWidth: 100,
                toolbar: {
                    show: false,
                },
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '25%',
                    endingShape: 'rounded',
                },
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                show: true,
                width: 1,
                colors: ['transparent'],
            },
            xaxis: {
                categories: this.monthInterruptionCategories,
            },
            yaxis: {
                labels: {
                    show: true,
                    style: {
                        fontSize: '11px',
                    },
                },
                title: {
                    text: 'Cantidad',
                },
            },
            colors: ['#F26935', '#F9A31B'],
            fill: {
                opacity: 1,
                gradient: {
                    enabled: true,
                    opacityFrom: 0.55,
                    opacityTo: 0,
                },
            },
            tooltip: {
                y: {
                    formatter: function(val) {
                        return val + ' interrupciones';
                    },
                },
            },
        };
    }

    getMonthLabel(monthNumberToCompare: number) {
        const currentYear: number = new Date().getFullYear();
        const lastYear: number = currentYear - 1;
        const currentMonth: number = new Date().getMonth() + 1;

        const monthFullName: string = getMonthShortName(monthNumberToCompare);
        const monthShortName: string =
            monthFullName.charAt(0).toUpperCase() + monthFullName.slice(1);

        if (monthNumberToCompare === currentMonth) {
            // current month
            return `${monthShortName} ${currentYear}`;
        } else if (monthNumberToCompare - currentMonth < 0) {
            // last year months
            return `${monthShortName} ${currentYear}`;
        } else {
            // current year months
            return `${monthShortName} ${lastYear}`;
        }
    }

    getIncidentValue(dashboardContent, month, dataCcs, dataVal) {
        let hasValueCcs: boolean = false;
        let hasValueVal: boolean = false;

        dashboardContent.forEach(element => {
            if (
                element.month === month &&
                element.dataCenterId === DataCenters.DATA_CENTER_CARACAS.id
            ) {
                hasValueCcs = true;
                dataCcs.push(parseInt(element.total));
            }

            if (
                element.month === month &&
                element.dataCenterId === DataCenters.DATA_CENTER_VALENCIA.id
            ) {
                hasValueVal = true;
                dataVal.push(parseInt(element.total));
            }
        });

        if (!hasValueVal) {
            dataVal.push(0);
        }

        if (!hasValueCcs) {
            dataCcs.push(0);
        }
    }

    getLastAndCurrentYearMonthOptions(dashboardContent, dataCcs, dataVal) {
        const currentMonth: number = new Date().getMonth() + 1;
        let month: number = currentMonth - 6 + 13;

        for (month; month < 13; month++) {
            this.monthInterruptionCategories.push(this.getMonthLabel(month));
            this.getIncidentValue(dashboardContent, month, dataCcs, dataVal);
        }

        for (let i = 1; i <= currentMonth; i++) {
            this.monthInterruptionCategories.push(this.getMonthLabel(i));
            this.getIncidentValue(dashboardContent, i, dataCcs, dataVal);
        }
    }

    getCurrentYearMonthOptions(dashboardContent, dataCcs, dataVal) {
        const currentMonth: number = new Date().getMonth() + 1;

        for (let i = currentMonth - 5; i <= currentMonth; i++) {
            this.monthInterruptionCategories.push(this.getMonthLabel(i));
            this.getIncidentValue(dashboardContent, i, dataCcs, dataVal);
        }
    }

    getMonthDataCenterIncidentsChartOptions() {
        const dataCcs: number[] = [];
        const dataVal: number[] = [];
        const currentMonth: number = new Date().getMonth() + 1;

        if (currentMonth < 6) {
            this.getLastAndCurrentYearMonthOptions(
                this.totalDataCenterMonthIncidents,
                dataCcs,
                dataVal,
            );
        } else {
            this.getCurrentYearMonthOptions(this.totalDataCenterMonthIncidents, dataCcs, dataVal);
        }

        this.monthInterruptionSeries.push({
            name: DataCenters.DATA_CENTER_CARACAS.alias,
            data: dataCcs,
        });

        this.monthInterruptionSeries.push({
            name: DataCenters.DATA_CENTER_VALENCIA.alias,
            data: dataVal,
        });
    }

    @layout.Mutation(LayoutMutations.CHANGE_TITLE)
    changeTitle!: (title: LayoutTitle) => void;

    @reportsDashboard.Action(ReportsDashboardActions.FETCH_DASHBOARD_DATA)
    fetchDashboard!: () => Promise<RequestResponse>;

    @reportsDashboard.Getter(ReportsDashboardGetters.GET_QUARTER_SUMMARY_CONTENT)
    quarterSummaryContent!: QuarterSummaryContent;

    @reportsDashboard.Getter(ReportsDashboardGetters.GET_MONTH_INTERRUPTION_SUMMARY)
    monthInterruptionSummary!: MonthInterruptionSummary[];

    @reportsDashboard.Getter(ReportsDashboardGetters.GET_TOTAL_MONTH_INCIDENTS)
    totalDataCenterMonthIncidents!: DatacenterMonthIncident[];

    @reportsDashboard.Getter(ReportsDashboardGetters.GET_DATACENTER_BUILDINGS)
    dataCenterBuildings!: DatacenterBuilding[];
}
